import React from 'react';

const AvailableSponsorships = ({ sponsorships, eventSlug }) => (
  <div className='mt-40 pt-40 border-top'>
    <label className='t1 w3 mb-32'>Choose from available sponsorships</label>
    <div className='sponsors card-list'>
      {sponsorships.map((sponsorship) => {
        const { id, name, availableSlots, tokenPrice, slug } = sponsorship;
        return (
          <div className='sponsorship-card' key={id}>
            <div className='display-flex flex-column pl-40 pt-32'>
              <p className='t3 w3'>{name}</p>
              <p className='mb-0'>{availableSlots} remaining</p>
              <a
                className='text-black underline'
                onClick={(e) => e.preventDefault()} //Do nothing until product design is updated
              >
                Click for details
              </a>
            </div>
            <div className='pl-40 pr-40 pt-20'>
              <p className='t2 w3 mb-32'>{tokenPrice} credits</p>
              {availableSlots > 0 ? (
                <a
                  className='btn w3'
                  href={`${eventSlug}/sponsorship_checkout/${slug}`}
                >
                  Choose
                </a>
              ) : (
                <a className='btn w3 disabled' disabled>
                  Sold out
                </a>
              )}
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

export default AvailableSponsorships;
